import Component from "@glimmer/component";
import { concat } from "@ember/helper";
import DUserAvatar from "discourse/ui-kit/d-user-avatar";
import DUserLink from "discourse/ui-kit/d-user-link";
import dAvatar from "discourse/ui-kit/helpers/d-avatar";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";
import dFormatDate from "discourse/ui-kit/helpers/d-format-date";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";
import userDisplayName from "../lib/user-display-name";
import CommunityFeedbackMediaStrip from "./community-feedback-media-strip";

export default class CommunityFeedbackCard extends Component {
  get authorDisplayName() {
    return userDisplayName(this.args.item.author);
  }

  get claimantDisplayName() {
    return userDisplayName(this.args.item.claimed_by);
  }

  get media() {
    if (this.args.item.media?.length) {
      return this.args.item.media;
    }

    return this.args.item.preview_url
      ? [{ url: this.args.item.preview_url }]
      : [];
  }

  <template>
    <article class="community-feedback-card">
      <div class="community-feedback-card__topline">
        <DUserLink
          @user={{@item.author}}
          class="community-feedback-card__author"
        >
          {{dAvatar @item.author imageSize="small" loading="lazy"}}
          <div class="community-feedback-card__author-copy">
            <strong>{{this.authorDisplayName}}</strong>
            <span>
              {{#if @item.author.title}}
                {{@item.author.title}}
                <span aria-hidden="true"> · </span>
              {{/if}}
              {{i18n
                (if
                  @isWish
                  "community_feedback.wishes.type_tag"
                  "community_feedback.progress_tag"
                )
              }}
            </span>
          </div>
        </DUserLink>
        <time class="community-feedback-card__date" datetime={{@item.created_at}}>
          {{dFormatDate @item.created_at format="medium"}}
        </time>
      </div>

      <div
        class={{dConcatClass
          "community-feedback-card__status"
          (concat "--" @item.status)
        }}
      >
        {{i18n (concat "community_feedback.statuses." @item.status)}}
      </div>

      <a class="community-feedback-card__content-link" href={{@item.url}}>
        <h2 class="community-feedback-card__title">{{@item.title}}</h2>
        {{#if @item.excerpt}}
          <p class="community-feedback-card__excerpt">{{@item.excerpt}}</p>
        {{/if}}
      </a>

      <CommunityFeedbackMediaStrip
        @media={{this.media}}
        @title={{@item.title}}
        @url={{@item.url}}
      />

      {{#if @item.claimed_by}}
        <DUserLink
          @user={{@item.claimed_by}}
          class="community-feedback-card__claimant"
        >
          {{i18n
            "community_feedback.wishes.claimed_by"
            username=this.claimantDisplayName
          }}
        </DUserLink>
      {{/if}}

      <footer class="community-feedback-card__footer">
        <div class="community-feedback-card__tags">
          {{#if @item.game_name}}
            <span class="community-feedback-card__tag --game">
              {{@item.game_name}}
            </span>
          {{/if}}
          {{#each @item.tags as |tag|}}
            <a
              href={{concat "/tag/" tag}}
              class="community-feedback-card__tag --topic"
            >
              {{tag}}
            </a>
          {{/each}}
        </div>
        <div class="community-feedback-card__metrics">
          <span>
            {{dIcon "eye"}}
            {{i18n "community_feedback.views" count=@item.views}}
          </span>
          <span>
            {{dIcon "comment"}}
            {{i18n "community_feedback.replies" count=@item.reply_count}}
          </span>
          {{#if @item.participants.length}}
            <span class="community-feedback-card__participants">
              {{#each @item.participants as |participant|}}
                <DUserAvatar
                  @user={{participant}}
                  @size="tiny"
                  @lazy={{true}}
                  @ariaLabel={{i18n
                    "user.profile_possessive"
                    username=participant.username
                  }}
                />
              {{/each}}
            </span>
          {{/if}}
        </div>
      </footer>
    </article>
  </template>
}
